import React from 'react';
import Header from './Header';
import MobileNav from './MobileNav';
import { cn } from '../../lib/utils';

const Layout = ({ 
  children, 
  title,
  showBack = false,
  showStats = true,
  showNav = true,
  transparentHeader = false,
  className,
  contentClassName
}) => {
  return (
    <div className={cn('min-h-screen bg-background', className)}>
      <Header 
        title={title}
        showBack={showBack}
        showStats={showStats}
        transparent={transparentHeader}
      />
      
      <main className={cn(
        'max-w-lg mx-auto',
        showNav && 'pb-20 md:pb-6',
        contentClassName
      )}>
        {children}
      </main>

      {showNav && <MobileNav />}
    </div>
  );
};

export default Layout;
